export default __webpack_public_path__ + "static/media/d.fe5e0cf2.gif";